import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms';
import { UploadDriversComponent } from './upload-drivers.component';
import { UploadDriversRoutingModule } from './upload-drivers-route.module';
import {ToastModule} from 'primeng/toast';
import { FileUploadModule } from 'primeng/fileupload';
import {TableModule} from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UploadDriversRoutingModule,
    ToastModule,
    FileUploadModule,
    TableModule,
    TranslateModule
  ],
  declarations: [UploadDriversComponent]
})
export class UploadDriversModule { }
